import { utils, i18next, anodum } from '@yola/ws-sdk';

const createIframeCodeValidator = (editorError) => (code) => {
  if (editorError) {
    return editorError;
  }

  if (!code) {
    return i18next.t('Invalid embed code. The empty embed code is not allowed.');
  }

  const doc = anodum.parseDocumentFromString(code);

  const containsIframesOnly = [...doc.body.childNodes].every(
    (node) => anodum.isElementNode(node) && anodum.isTag(node, 'iframe')
  );

  if (!containsIframesOnly) {
    return i18next.t('Invalid embed code. Any non-iframe html is not allowed.');
  }

  const iframes = doc.querySelectorAll('iframe');

  if (iframes.length === 0) {
    return i18next.t('Invalid embed code. Iframe tag is not found.');
  }

  if (iframes.length > 1) {
    return i18next.t('Invalid embed code. Multiple iframe tags are not allowed.');
  }

  const [iframe] = iframes;
  const iframeSrc = iframe.getAttribute('src');

  if (!iframeSrc || !utils.validation.isURL(iframeSrc)) {
    return i18next.t('Invalid embed code. Iframe source is not specified.');
  }

  return null;
};

export default createIframeCodeValidator;
